import React from 'react';
import Card from '../base/Card';
import Button from '../base/Button';
import './PlaceholderStyles.css';

function FocusFionaPlaceholder() {
  return (
    <div className="placeholder-container">
      <Card className="placeholder-card feature-placeholder">
        <div className="placeholder-icon">🤖</div>
        <h2 className="placeholder-title title-1">Focus Fiona</h2>
        <p className="placeholder-description body-text">
          Your AI-powered focus coach. Get personalized recommendations, adaptive strategies,
          and real-time support to optimize your productivity and well-being.
        </p>
        <div className="placeholder-features">
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Personalized coaching</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Adaptive strategies</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">24/7 support</span>
          </div>
        </div>
        <div className="placeholder-actions">
          <Button variant="primary" showArrow disabled>
            Chat with Fiona
          </Button>
        </div>
        <p className="placeholder-note caption">
          Ready for implementation. Build your AI coach interface here.
        </p>
      </Card>
    </div>
  );
}

export default FocusFionaPlaceholder;








